import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { OrderPipe } from 'ngx-order-pipe';


@Component({
  selector: 'app-affirmations',
  templateUrl: './affirmations.page.html',
  styleUrls: ['./affirmations.page.scss'],
})
export class AffirmationsPage implements OnInit {
  // @ViewChild('slider', { read: ElementRef })slider: ElementRef;
  public affirmations: any;
  sliderOpts = {
    autoplay: true,
    // speed: 2000,
    zoom: {
      maxRatio: 5
    }
  };
  public userId: any;

  constructor(
    private router: Router,
    public afAuth: AngularFireAuth,
    public modalController: ModalController,
    public afDB: AngularFireDatabase,
    public afSG: AngularFireStorage,
    private orderPipe: OrderPipe,
    private insomnia: Insomnia
  ) {
    this.insomnia.keepAwake()
    .then(
      () => console.log('insomnia success'),
      () => console.log('insomnia error')
    );
  }


  ngOnInit() {
    this.afAuth.authState.subscribe(auth => {
      if (!auth) {
        console.log('non connecté');
        this.router.navigateByUrl('/login');
      } else {
        console.log('Connecté: ' + auth.uid);
        this.userId = auth.uid;
        this.getAffirmations();
      }
    });
  }

  // getAffirmations() {
  //   const affirmationsRef = this.afDB.list('Affirmations/' + this.userId);
  //   affirmationsRef.snapshotChanges(['child_added'])
  //   .subscribe(actions => {
  //     const that = this;
  //     const data = [];
  //     actions.forEach((action: any) => {
  //       data.push({
  //         text: action.payload.val().text
  //       });
  //       this.affirmations = this.orderPipe.transform(data, 'order');
  //     });
  //   });
  // }

  getAffirmations() {
    const affirmationsRef = this.afDB.list('Affirmations/' + this.userId);
    affirmationsRef.snapshotChanges(['child_added', 'child_removed'])
    .subscribe(actions => {
      const data = [];
      let count = 0;
      actions.forEach(action => {
        if (action.payload.exportVal().order === '') {
          this.afDB.object('Affirmations/' + this.userId + '/' + action.payload.key + '/order').set(count);
          data.push({
            key: action.payload.key,
            text: action.payload.exportVal().text,
            order: count
          });
        } else {
          data.push({
            key: action.payload.key,
            text: action.payload.exportVal().text,
            order: action.payload.exportVal().order
          });
        }
        count++;
      });
      this.affirmations = this.orderPipe.transform(data, 'order');
    });
  }

  async closeModal() {
    this.modalController.dismiss();
  }

  slidesDidLoad(slides) {
    slides.startAutoplay();
  }

}
